(function () {

    "use strict";

    angular
        .module('harriApp')
        .controller("SSORedirectController", SSORedirectController);

    SSORedirectController.$inject = ['$scope', '$state', '$window', '$stateParams', 'hUser'];

    function SSORedirectController($scope, $state, $window, $stateParams, hUser) {
        var self = this;
        self.error = false;
        self.errorCode = {};
        self.errorDescription = {};

        var provider = '';
        if ($state.current.name === 'sso_hallandwoodhouse') {
            provider = 'hallandwoodhouse';
        } else if ($state.current.name === 'sso_connectivity_source') {
            provider = 'connectivity-source';
        } else if ($state.current.name === 'sso_subway') {
            provider = 'subway';
        } else if ($state.current.name === 'sso_jib') {
            provider = 'jack-in-the-box';
        } else {
            provider = 'Radisson';
        }

        var init = function () {
            hLoginManager.getFederateSignInLink(provider).then(function(redirectUrl){
                window.location.href = redirectUrl;
            }, function (err) {
                hLog(provider.toUpperCase(), 'REDIRECT_REDIRECT', err);
                betterSomethingWentWrong();
            });
        };
        init();
    }

})();
